export async function copyStringToClipboard(link: string): Promise<void> {
  // If the current URL is not an HTTP URL, we need to use the textarea method
  // So this is only used in DEVELOPMENT
  if (!window.isSecureContext) {
    const textArea = document.createElement('textarea');
    textArea.value = link;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    return;
  }

  await navigator.clipboard.writeText(link);
}
